import * as React from "react"

import { cn } from "#/lib/utils"

function Textarea({
  className,
  ...props
}) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex field-sizing-content min-h-16 w-full rounded-sm border border-gray-300 bg-transparent px-2.5 py-2 text-base text-gray-700 transition-colors outline-none placeholder:text-muted-foreground hover:border-primary-500 hover:ring-1 hover:ring-primary-500/35 focus-visible:border-primary-500 focus-visible:ring-1 focus-visible:ring-primary-500/35 disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 disabled:hover:border-gray-300 disabled:hover:ring-0 read-only:hover:border-gray-300 read-only:hover:ring-0 aria-invalid:border-red-500 aria-invalid:ring-1 aria-invalid:ring-red-500/35 aria-invalid:hover:border-red-500 aria-invalid:hover:ring-red-500/35 aria-invalid:focus-visible:border-red-500 aria-invalid:focus-visible:ring-red-500/35 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80",
        className
      )}
      {...props} />
  );
}

export { Textarea }
